export default "__VITE_ASSET__Cu7I7y6a__"